customElements.component = 'product-color-disclaimer';

if (!customElements.get(customElements.component)) {

    class productColorDisclaimer extends HTMLElement {

        connectedCallback() {
            this.reposition = this.reposition.bind(this);
            this.onBreakpointChange = this.onBreakpointChange.bind(this);

            this.details = this.querySelector('[data-color-disclaimer]');
            this.desktopQuery = window.matchMedia('(min-width: 768px)');
            this.onBreakpointChange();

            document.addEventListener('swatches-ready', this.reposition);

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.reposition);
            }

            if (this.desktopQuery.addEventListener) {
                this.desktopQuery.addEventListener('change', this.onBreakpointChange);
            } else {
                this.desktopQuery.addListener(this.onBreakpointChange);
            }
        }

        disconnectedCallback() {
            document.removeEventListener('swatches-ready', this.reposition);
            document.removeEventListener('DOMContentLoaded', this.reposition);

            if (this.desktopQuery) {
                if (this.desktopQuery.removeEventListener) {
                    this.desktopQuery.removeEventListener('change', this.onBreakpointChange);
                } else {
                    this.desktopQuery.removeListener(this.onBreakpointChange);
                }
            }
        }

        onBreakpointChange() {
            this.syncDisclosure();
            this.reposition();
        }

        syncDisclosure() {
            if (!this.details) {
                return;
            }

            const summary = this.details.querySelector('summary');

            if (this.desktopQuery.matches) {
                this.details.setAttribute('open', '');
                if (summary) {
                    summary.setAttribute('tabindex', '-1');
                }
            } else {
                this.details.removeAttribute('open');
                if (summary) {
                    summary.removeAttribute('tabindex');
                }
            }
        }

        getColorAnchor() {
            const scope = this.closest('component-addtocart, form, [data-product-form]') || document;

            const groupSwatch = scope.querySelector('product-color-group-swatch');
            if (groupSwatch) {
                return groupSwatch.closest('.swatch-option') || groupSwatch;
            }

            const options = scope.querySelectorAll('.swatch-option, [data-option]');
            for (let i = 0; i < options.length; i++) {
                const el = options[i];
                const type = (el.getAttribute('data-type') || '').trim().toLowerCase();
                const name = (el.getAttribute('data-option') || '').trim().toLowerCase();
                if (type === 'color' || name === 'color' || name === 'colour') {
                    return el;
                }
            }

            return null;
        }

        reposition() {
            const anchor = this.getColorAnchor();

            if (!anchor) {
                return;
            }

            if (this.desktopQuery && this.desktopQuery.matches) {
                if (anchor.lastElementChild !== this) {
                    anchor.appendChild(this);
                }
                return;
            }

            const label = anchor.querySelector(':scope > .swatches__swatch-label, :scope > .swatch-label');

            if (label) {
                if (label.lastElementChild !== this) {
                    label.appendChild(this);
                }
            } else if (anchor.firstElementChild !== this) {
                anchor.prepend(this);
            }
        }
    }

    customElements.define(customElements.component, productColorDisclaimer);
}
